module.exports = __webpack_public_path__ + "details2.8b10cc49.jpg";